<div
  class="segmented"
  role="radiogroup"
  [class.segmented-disabled]="disabled"
  [attr.aria-label]="ariaLabel || label || null"
>
  <span class="segmented-label" *ngIf="label">{{ label }}</span>

  <button
    *ngFor="let option of options; let i = index"
    class="segmented-option"
    type="button"
    role="radio"
    [class.segmented-option-active]="option.value === value"
    [attr.aria-checked]="option.value === value"
    [attr.tabindex]="isTabbable(option, i) ? 0 : -1"
    [attr.title]="option.hint || null"
    [disabled]="disabled"
    (click)="select(option)"
    (keydown)="onKeydown($event, i)"
  >
    {{ option.label }}
    <span class="segmented-count" *ngIf="option.count !== undefined">{{ option.count }}</span>
  </button>
</div>
